/**
 * @file Missing fields alert.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Alert from './Alert';

const propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.any,
    }),
  ),
  customMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
};

const MissingFieldsAlert = ({ fields, customMessage, ...props }) => {
  const missingFields = fields.filter(field => !field.value);
  if (missingFields.length === 0) {
    return null;
  }

  return (
    <Alert type="info" {...props}>
      {customMessage || (
        <p className="text-bold">
          Please fill in these fields before continuing.
        </p>
      )}
      <ul>
        {missingFields.map(field => (
          <li key={field.name}>{field.name}</li>
        ))}
      </ul>
    </Alert>
  );
};

MissingFieldsAlert.propTypes = propTypes;

export default MissingFieldsAlert;
